import posthog from 'posthog-js';
import { getPlatform, isNativeMobileApp } from './platformDetector';
import { APP_VERSION } from './appVersion';

const posthogConfig: any = {
  api_host: 'https://d.friday-technologies.com',
  person_profiles: 'identified_only',
  // The PostHog TS definitions here are looser; keep as `any` for custom fields.
  enableExceptionAutocapture: true,
  defaults: '2026-01-30',
  // Recording only runs if "Record user sessions" is also enabled in the
  // PostHog project settings. Inputs stay masked — DMs are sensitive.
  session_recording: {
    maskAllInputs: true,
  },
};

posthog.init('phc_TKETVSqLUA5pwOSmV0Zxk3a88oO1H12OBSUPVdn6dCr', posthogConfig);

// Super properties: stamped on every event so web vs Android and app version
// are always segmentable (and available to feedback diagnostics).
posthog.register({
  platform: getPlatform(),
  is_native: isNativeMobileApp(),
  app_version: APP_VERSION,
});

// Scroll depth tracking. Fires each milestone at most once per mount — a jump
// past a milestone still counts, and sitting exactly on one doesn't re-fire.
export const trackScrollDepth = (page: string): (() => void) => {
  const milestones = [25, 50, 75, 100];
  const fired = new Set<number>();

  const handleScroll = () => {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrolled = window.scrollY;
    const scrollPercent = scrollHeight > 0 ? Math.round((scrolled / scrollHeight) * 100) : 0;

    milestones.forEach((milestone) => {
      if (scrollPercent >= milestone && !fired.has(milestone)) {
        fired.add(milestone);
        posthog.capture('scroll_depth', {
          page,
          scroll_percentage: milestone,
        });
      }
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  return () => window.removeEventListener('scroll', handleScroll);
};

export default posthog;
